<template>
  <EchartsLayout :option="option"></EchartsLayout>
</template>

<script>
import { getCacheOrRequest } from "@/utils/index.js";
import ComponentBase from "@/components/mixin/ComponentBase.vue";
import EchartsLayout from "@/components/common/EchartsLayout.vue";

export default {
  mixins: [ComponentBase],
  props: {
    current_year: {
      type: Number,
      default: new Date().getFullYear(),
    },
  },
  components: {
    EchartsLayout,
  },
  data() {
    return {
      option: null,
    };
  },
  methods: {
    get_component_data() {
      getCacheOrRequest.call(this, {
        method: "post",
        url: `/com/getAcvitityTop`,
        param: {
          year: this.current_year,
          type: "报名",
        },
        success: (response) => {
          let arr = [];
          response.data &&
            response.data.data &&
            response.data.data.map &&
            response.data.data.map((item) => {
              arr.push({ 机构名: item.orgName, 活动参加人次: item.number });
            });

          // 更新配置
          this.option = {
            grid: { containLabel: true, bottom: 0 },
            series: [
              {
                type: "bar",
                showItemStyle: true,
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [
                      { offset: 1, color: "#FFCE2B" },
                      { offset: 0, color: "#FF8500" },
                    ],
                    globalCoord: false,
                  },
                  borderRadius: 20,
                },
                barWidth: 50,
              },
            ],
            title: { text: "单位：次", textStyle: { fontWeight: 700, fontSize: 54 } },
            tooltip: { textStyle: { fontSize: 54 } },
            xAxis: {
              axisLabel: {
                textStyle: {
                  fontSize: 54,
                  fontWeight: 700,
                },
              },
            },
            yAxis: {
              type: "category",
              inverse: true,
              axisLabel: {
                textStyle: {
                  fontSize: 54,
                  fontWeight: 700,
                },
              },
            },
            dataset: {
              source: [...arr],
            },
          };
        },
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped></style>
